import React, { useState } from "react";
import { getScrollbarSize } from "react-window";

import HeaderCell from "./HeaderCell";
import CheckboxCell from "./CheckboxCell";

function HeaderRow({
  columns,
  height,
  selectable,
  selectDisabled,
  handleSelectHeader,
  allSelected,
  sortBy,
  sortDir,
  handleSort,
  colFilters,
  handleColFilter,
  scrollBarActive,
}) {
  const [size] = useState(getScrollbarSize);

  return (
    <div style={{ display: "flex", width: "100%", height }}>
      {selectable && (
        <CheckboxCell
          selected={allSelected}
          onClick={handleSelectHeader}
          disabled={selectDisabled}
        />
      )}

      {columns.map(col => {
        const sortable = !col.disableSort;
        return (
          <HeaderCell
            sortable={sortable}
            sortDir={col.dataKey === sortBy ? sortDir : null}
            handleSort={sortable ? () => handleSort(col.dataKey) : null}
            filterable={col.filterable}
            filterValue={colFilters[col.dataKey]}
            handleColFilter={col.filterable ? value => handleColFilter(col.dataKey, value) : null}
            FilterInputComponent={col.FilterInputComponent}
            numeric={col.numeric}
            width={col.width}
            flexGrow={col.flexGrow}
            flexShrink={col.flexShrink}
            key={col.dataKey}
          >
            {col.label}
          </HeaderCell>
        );
      })}
      {scrollBarActive && <div style={{ width: size }} />}
    </div>
  );
}

export default React.memo(HeaderRow);
